// Central route registry. Used by App.js for routing AND by the backend
// sitemap generator (via the exported public route list).
// Keep in sync with App.js.

export const PUBLIC_ROUTES = [
  { path: "/", changefreq: "weekly", priority: 1.0 },
  { path: "/solutions/blister-printing", changefreq: "monthly", priority: 0.8 },
  { path: "/solutions/specialty-inks", changefreq: "monthly", priority: 0.8 },
  { path: "/solutions/printing-aids", changefreq: "monthly", priority: 0.8 },
  { path: "/solutions/coding-marking", changefreq: "monthly", priority: 0.8 },
  { path: "/solutions/cleaning-maintenance", changefreq: "monthly", priority: 0.8 },
  { path: "/solutions/production-consumables", changefreq: "monthly", priority: 0.8 },
  { path: "/products/blister-pack-violet-ink", changefreq: "monthly", priority: 0.7 },
  { path: "/products/blister-pack-inks-aid", changefreq: "monthly", priority: 0.7 },
  { path: "/products/indelible-ink", changefreq: "monthly", priority: 0.7 },
  { path: "/products/indelible-poly-inks-aid", changefreq: "monthly", priority: 0.7 },
  { path: "/products/porous-ink", changefreq: "monthly", priority: 0.7 },
  { path: "/products/non-porous-ink", changefreq: "monthly", priority: 0.7 },
  { path: "/products/pvc-reducer", changefreq: "monthly", priority: 0.7 },
  { path: "/products/ss-polyfine-inks-aid", changefreq: "monthly", priority: 0.7 },
  { path: "/products/screen-cleaning-aid", changefreq: "monthly", priority: 0.7 },
  { path: "/products/metal-stereos", changefreq: "monthly", priority: 0.7 },
  { path: "/products/solvent-hp-compatible-cartridge", changefreq: "monthly", priority: 0.7 },
  { path: "/products/water-based-hp-black-cartridge", changefreq: "monthly", priority: 0.7 },
  { path: "/products/production-consumables", changefreq: "monthly", priority: 0.7 },
  { path: "/industries/pharmaceutical", changefreq: "monthly", priority: 0.8 },
  { path: "/industries/food", changefreq: "monthly", priority: 0.6 },
  { path: "/technical-support", changefreq: "monthly", priority: 0.7 },
  { path: "/global-distribution", changefreq: "monthly", priority: 0.7 },
  { path: "/distributors", changefreq: "monthly", priority: 0.7 },
  { path: "/resources", changefreq: "monthly", priority: 0.6 },
  { path: "/blog", changefreq: "weekly", priority: 0.6 },
  { path: "/about", changefreq: "monthly", priority: 0.7 },
  { path: "/contact", changefreq: "monthly", priority: 0.8 },
  { path: "/request-sample", changefreq: "monthly", priority: 0.8 },
  { path: "/find-the-right-ink", changefreq: "monthly", priority: 0.8 },
  { path: "/privacy-policy", changefreq: "yearly", priority: 0.3 },
  { path: "/terms", changefreq: "yearly", priority: 0.3 },
  { path: "/cookie-policy", changefreq: "yearly", priority: 0.3 },
];

// Nav groupings for header/footer
export const SOLUTIONS_NAV = [
  { key: "blister_printing", path: "/solutions/blister-printing" },
  { key: "specialty_inks", path: "/solutions/specialty-inks" },
  { key: "printing_aids", path: "/solutions/printing-aids" },
  { key: "coding_marking", path: "/solutions/coding-marking" },
  { key: "cleaning_maintenance", path: "/solutions/cleaning-maintenance" },
  { key: "production_consumables", path: "/solutions/production-consumables" },
];

// Product hierarchy (§12) — three visually distinct groups shown top-to-bottom
// in the header PRODUCTS dropdown. `group` is consumed by the Header + any
// products index page to render section headings between the groups.
export const PRODUCTS_NAV = [
  // 1) PRIMARY SPECIALIST PRODUCTS
  { key: "blister_pack_violet_ink", path: "/products/blister-pack-violet-ink", group: "primary" },
  { key: "blister_pack_inks_aid", path: "/products/blister-pack-inks-aid", group: "primary" },
  { key: "indelible_ink", path: "/products/indelible-ink", group: "primary" },
  { key: "porous_ink", path: "/products/porous-ink", group: "primary" },
  { key: "non_porous_ink", path: "/products/non-porous-ink", group: "primary" },
  { key: "solvent_hp_cartridge", path: "/products/solvent-hp-compatible-cartridge", group: "primary" },
  { key: "water_hp_cartridge", path: "/products/water-based-hp-black-cartridge", group: "primary" },
  // 2) SUPPORTING PRINTING PRODUCTS
  { key: "indelible_poly_inks_aid", path: "/products/indelible-poly-inks-aid", group: "supporting" },
  { key: "pvc_reducer", path: "/products/pvc-reducer", group: "supporting" },
  { key: "ss_polyfine_inks_aid", path: "/products/ss-polyfine-inks-aid", group: "supporting" },
  { key: "screen_cleaning_aid", path: "/products/screen-cleaning-aid", group: "supporting" },
  { key: "metal_stereos", path: "/products/metal-stereos", group: "supporting" },
  // 3) ADDITIONAL PRODUCTION CONSUMABLES
  { key: "production_consumables", path: "/products/production-consumables", group: "additional" },
];

export const INDUSTRIES_NAV = [
  { key: "pharmaceutical", path: "/industries/pharmaceutical" },
  { key: "food", path: "/industries/food" },
];
